import { render, staticRenderFns } from "./packing-batch-manager.vue?vue&type=template&id=47b9898e&scoped=true&"
import script from "./packing-batch-manager.vue?vue&type=script&lang=ts&"
export * from "./packing-batch-manager.vue?vue&type=script&lang=ts&"
import style0 from "./packing-batch-manager.vue?vue&type=style&index=0&id=47b9898e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9898e",
  null
  
)

export default component.exports